/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { MercadoPagoQrPaymentModal } from '../../mercadopago/components/MercadoPagoQrPaymentModal';
import { useMercadoPagoQrSession } from '../../mercadopago/application/useMercadoPagoQrSession';
import type { SaleDetail } from '../domain/salesTypes';
import { formatSaleShortRefSuffix } from '../application/salePresentation';

type Props = {
  detail: SaleDetail | null;
  visible: boolean;
  onClose: () => void;
  onTerminal?: () => void;
  onVoidSale?: () => void;
};

export function SaleDetailMpQrModal(props: Props) {
  const { detail, visible, onClose, onTerminal, onVoidSale } = props;
  const saleId = detail?.id ?? null;
  const mpPayment = detail?.payments.find((p) => p.methodId === 'mercadopago_qr');

  const session = useMercadoPagoQrSession({
    saleId,
    visible,
    amount: mpPayment?.amount ?? detail?.pendingAmount ?? null,
    saleRef: detail?.shortId ?? (saleId ? formatSaleShortRefSuffix(saleId) : null),
    fiscalMode: detail?.fiscalMode,
    fiscalStatus: detail?.fiscalStatus,
    invoiceCae: detail?.invoiceCae,
    onTerminal,
  });

  return (
    <MercadoPagoQrPaymentModal
      visible={visible}
      phase={session.phase}
      loading={session.loading}
      error={session.error}
      qrData={session.qrData}
      qrUrl={session.qrUrl}
      amount={session.amount}
      saleRef={detail?.shortId ?? (saleId ? formatSaleShortRefSuffix(saleId) : null)}
      expiresAt={session.expiresAt}
      countdownSeconds={session.countdownSeconds}
      fiscalInvoiceLabel={session.fiscalInvoiceLabel}
      autoCloseProgress={session.autoCloseProgress}
      lastMpQrSaleId={saleId}
      onClose={onClose}
      onRegenerate={session.regenerateQr}
      onVoidSale={onVoidSale}
    />
  );
}
